import { Outlet } from 'react-router-dom';

const TeamDashboard = () => (
  <div>
    <Outlet />
  </div>
);

export default TeamDashboard;
